import { DEFAULT_PAGE_SIZE, Dataset, DtFilter, DtSort } from '@/components/data-table/helpers';
import { RootUserModel } from '../models/root-user.model';
import { get, post } from './sp-api.service';
import { JsonObject } from '../helpers';

const SAFE_LIMIT = 200;

type ListResponse = {
  count: number;
  data: JsonObject[];
};

export const getRootUsers = async (
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  dtSort?: DtSort,
  dtFilter?: DtFilter
): Promise<Dataset<RootUserModel>> => {
  const response = (await post('/user/root-users/search', {
    page: 1,
    pageSize: SAFE_LIMIT,
    count: false,
    sort: [dtSort ? { [dtSort.columnName]: dtSort.direction } : { name: 'asc' }],
  })) as ListResponse;

  if (!response?.data) {
    return {
      page,
      pageSize,
      rows: [],
      total: 0,
    };
  }

  let rows: RootUserModel[] = response.data.map((data) => new RootUserModel(data));

  if (dtFilter?.keyword) {
    const safeKeyword = String(dtFilter?.keyword).toLowerCase();
    rows = rows.filter(
      ({ name, email }) =>
        name.toLowerCase().includes(safeKeyword) || email.toLowerCase().includes(safeKeyword)
    );
  }

  const total = rows.length;

  // Paginate
  const startIndex = page * pageSize;
  rows = rows.slice(startIndex, startIndex + pageSize);

  return {
    page,
    pageSize,
    rows,
    total,
  };
};

export const getRootUserById = async (userId: string): Promise<RootUserModel | null> => {
  const response = await get(`/user/root-users/${userId}`);
  return response ? new RootUserModel(response as JsonObject) : null;
};
